import React, { useEffect, useState } from "react";
import { Modal, Space, Button } from "react_reusable_components";
import variables from "../../themes/base/styles/variables";
import {
  disabledDate,
  getLocalizedMessage,
} from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import { AUDIT_STATUSES, currentAuditType } from "../../constants";
import DatePickerContainer from "../DatePickerContainer/DatePickerContainer";

const BlockUserModalStyles = {
  changed: {
    fontSize: variables.fontSizeXlarge,
    fontWeight: variables.fontWeightBold,
  },
  changedSuccess: {
    fontSize: variables.fontSizeXlarge,
    fontWeight: variables.fontWeightBold,
    textAlign: variables.alignCenter,
    color: variables.textDefault,
    lineHeight: variables.lineHeightXxlarge,
    display: variables.dBlock,
  },
  BlockButton: {
    fontSize: variables.fontSizeSmall,
    fontWeight: variables.fontWeightNormal,
    lineHeight: variables.lineHeightNormal,
    flex: 1,
  },
  CancelButton: {
    fontSize: variables.fontSizeSmall,
    fontWeight: variables.fontWeightNormal,
    lineHeight: variables.lineHeightNormal,
    flex: 1,
    border: `1px solid ${variables.grey4}`,
  },
  modalContent: {
    all: variables.unset,
    width: variables.fullWidth,
  },
  modalMaskStyle: {
    backdropFilter: variables.highBlur,
    background: variables.blurBackground,
  },
  btnContainer: { display: variables.dFlex, gap: variables.gapSmall },
  textarea: {
    width: variables.fullWidth,
    fontSize: variables.fontSizeNormal,
  },
  centerImg: {
    display: variables.dFlex,
    justifyContent: variables.alignCenter,
    position: "relative",
  },
  cross: {
    position: "absolute",
    right: "0",
    top: "0",
    height: variables.iconHeightLarge,
    width: variables.iconWidthLarge,
    cursor: "pointer",
  },
};

export default function SetAuditTypeContainer({
  open,
  onClose,
  onSubmit,
  record,
  isReAudit,
}) {
  const [remark, setRemark] = useState("");
  const [reAuditDate, setReAuditDate] = useState("");

  const intl = useIntl();
  const onFormSubmit = (e) => {
    e.preventDefault();
    let values = { auditMedium: remark };
    if (isReAudit) {
      values = {
        ...values,
        reAuditDueDate: reAuditDate,
        status: AUDIT_STATUSES.RE_AUDIT_PENDING,
      };
    }
    onSubmit(values);
  };

  useEffect(() => {
    const selectedAuditMedium = currentAuditType?.find(
      (item) => item.value === record?.auditMedium
    );
    if (selectedAuditMedium) setRemark(selectedAuditMedium?.value);
    else setRemark(currentAuditType[0]?.value);
  }, [record]);

  return (
    <Modal
      maskClosable={false}
      maskStyle={BlockUserModalStyles.modalMaskStyle}
      centered
      open={open}
      closable={false}
      footer={null}
      width={400}
    >
      <form onSubmit={onFormSubmit}>
        <Space
          direction="vertical"
          align="center"
          style={BlockUserModalStyles.modalContent}
        >
          <div style={BlockUserModalStyles.centerImg}>
            <img
              style={BlockUserModalStyles.cross}
              src={"/icons/close.svg"}
              alt="block-user"
              onClick={onClose}
            />
          </div>
          <CustomSelect
            required
            label={getLocalizedMessage(
              intl,
              "auditListing.action.setAuditTypeModalLabel"
            )}
            placeholder={getLocalizedMessage(
              intl,
              "auditListing.action.setAuditTypeModalLabel"
            )}
            onChange={(e) => {
              setRemark(e);
            }}
            value={remark || null}
            options={currentAuditType}
          />
          {isReAudit && (
            <DatePickerContainer
              size={"small"}
              required
              onChange={(date) => setReAuditDate(date)}
              label={getLocalizedMessage(
                intl,
                "auditListing.action.setReAuditDateNType"
              )}
              value={reAuditDate}
              disabledDate={(current) => disabledDate(current, true)}
            />
          )}
          <div style={BlockUserModalStyles.btnContainer}>
            <Button
              style={BlockUserModalStyles.CancelButton}
              icon={null}
              type="text"
              onClick={onClose}
            >
              {getLocalizedMessage(intl, "button.text.cancel")}
            </Button>
            <Button
              style={{
                ...BlockUserModalStyles.BlockButton,
                ...{
                  backgroundColor:
                    (!isReAudit || reAuditDate) && variables.successGreen,
                },
              }}
              icon={null}
              htmlType="submit"
              disabled={isReAudit && !reAuditDate}
            >
              {getLocalizedMessage(intl, "button.submit")}
            </Button>
          </div>
        </Space>
      </form>
    </Modal>
  );
}
